var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
var CategoryNaviItem = (function (_super) {
    __extends(CategoryNaviItem, _super);
    function CategoryNaviItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.finalUrl = null;
        return _this;
    }
    CategoryNaviItem.prototype.mounted = function () {
        this.finalUrl = this.url;
        if (this.termPath && this.termPath.length > 0) {
            this.finalUrl += this.finalUrl.indexOf('?') > -1 ? '&' : '?';
            this.finalUrl += "term=" + encodeURIComponent(this.termPath.join(';'));
        }
    };
    __decorate([
        Prop({ type: String })
    ], CategoryNaviItem.prototype, "icon", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryNaviItem.prototype, "title", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryNaviItem.prototype, "description", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryNaviItem.prototype, "url", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], CategoryNaviItem.prototype, "showArrow", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], CategoryNaviItem.prototype, "showIcon", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({}); } })
    ], CategoryNaviItem.prototype, "tags", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryNaviItem.prototype, "size", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], CategoryNaviItem.prototype, "showDescription", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], CategoryNaviItem.prototype, "termPath", void 0);
    __decorate([
        Prop()
    ], CategoryNaviItem.prototype, "hatching", void 0);
    CategoryNaviItem = __decorate([
        Component({})
    ], CategoryNaviItem);
    return CategoryNaviItem;
}(Vue));
export default CategoryNaviItem;
